// SubmittedForLApproval.js - Corrected version
const SubmittedForLApproval = (initiatives) => {
  if (!initiatives || !Array.isArray(initiatives)) {
    return [];
  }

  const initiativesAndSpecificHistory = initiatives
    .map((init) => {
      if (!init.history || !Array.isArray(init.history)) {
        return { initiative: init, history: [] };
      }

      const specificHistory = init.history
        .filter((entry) => entry && entry.action) // Ensure entry is not null/undefined
        .filter(
          (entry) =>
            entry.action.includes('Changed from L0 to Submitted for L1 Approval') ||
            entry.action.includes('Changed from L1 to Submitted for L2 Approval') ||
            entry.action.includes('Changed from L2 to Submitted for L3 Approval') ||
            entry.action.includes('Changed from L3 to Submitted for L4 Approval') ||
            entry.action.includes('Changed from L4 to Submitted for L5 Approval') ||
            entry.action.includes('Changed from L4 to Submitted for L3 Approval')
        )
        .map((entry) => ({
          action: entry.action.trim(), // Trim to remove any trailing spaces
          timestamp: entry.timestamp,
        }));

      return {
        initiative: init,
        history: specificHistory,
      };
    })
    .filter((result) => result.history.length > 0);

  initiativesAndSpecificHistory.forEach((item) => {
    if (item.history.length > 0) {
      const actionTimestampPairs = {};

      item.history.forEach((entry) => {
        // Keep only the latest timestamp for each action
        if (
          !actionTimestampPairs[entry.action] ||
          new Date(entry.timestamp) > new Date(actionTimestampPairs[entry.action])
        ) {
          actionTimestampPairs[entry.action] = entry.timestamp;
        }
      });

      // Add the actionTimestampPairs to the initiative object
      item.initiative.actionTimestampPairs = actionTimestampPairs;
    }
  });

  // Return all initiatives with their actionTimestampPairs (including those without history)
  return initiatives.map(init => {
    const found = initiativesAndSpecificHistory.find(item => item.initiative._id === init._id);
    if (found && found.initiative.actionTimestampPairs) {
      return found.initiative;
    }
    return { ...init, actionTimestampPairs: {} };
  });
};

export default SubmittedForLApproval;